import { withViewModel } from '../../../../../../../infrastructure/components/with-view-model';
import { ManageMeetingLinkModalPresentation } from './manage-meeting-link-modal.presentation';
import { ManageMeetingLinkModalProps, ManageMeetingLinkModalViewModel } from './manage-meeting-link-modal.viewmodel';

export const ManageMeetingLinkModal = withViewModel(ManageMeetingLinkModalPresentation, async (props: ManageMeetingLinkModalProps) => {
    return new ManageMeetingLinkModalViewModel(props);
});
